export class FeesEstimationAdminDto {
    RequestId: string;
    AdminEmail: string;
    MoreInformation: string;
    Decision: number;
    InsuranceValue: number;
    FeeValue: number;
    MarineRequirements: string;
    TotlFees: number;
    MeasurementDescription :string;
}